type CommonOptions = {
  appHost?: string;
  appId: string;
  pathEntity: string;
  pathEntityId?: string;
};

type TokenOptions = CommonOptions & {
  token: string;
};

type ShareTokenOptions = CommonOptions & {
  shareToken: string;
};

export const getWebsocketUrl = (
  options: TokenOptions | ShareTokenOptions,
): string => {
  const {
    appHost = window.location.host,
    appId,
    pathEntity,
    pathEntityId,
  } = options;

  const token = 'token' in options ? options.token : undefined;
  const shareToken = 'shareToken' in options ? options.shareToken : undefined;

  let host = '';
  let protocol;
  const url = pathEntityId
    ? `/${pathEntity}/${pathEntityId}/`
    : `/${pathEntity}/`;

  if (window.location.protocol === 'https:') {
    protocol = 'wss';
  }
  if (window.location.protocol === 'http:') {
    protocol = 'ws';
  }
  if (!protocol) {
    protocol = 'wss';
  }
  if (appHost) {
    host = appHost.replace(/^(https?:|)\/\//, '');
  }
  if (shareToken) {
    return `${protocol}://${host}/ws${url}?share_token=${shareToken}&app_id=${appId}`;
  }

  return `${protocol}://${host}/ws${url}?token=${token}&app_id=${appId}`;
};
